import * as S from './styles'

interface TableTitleProps {
  children: React.ReactNode
}

export const TableTitle = ({ children }: TableTitleProps) => {
  return <S.Wrapper>{children}</S.Wrapper>
}
